import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=f2f95fc0"
import script from "./Agents.vue?vue&type=script&lang=ts"
export * from "./Agents.vue?vue&type=script&lang=ts"
import style0 from "./Agents.vue?vue&type=style&index=0&id=f2f95fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports